<template>
  <section>
    <div
      v-for="text in tagContent.slice(0, wrapNumber)"
      :key="text"
      class="inline-block cursor-pointer px-2 py-1 mr-1 text-xs font-medium text-gray-600 border border-inputGrey-600 rounded-2xl bg-inputGrey-500"
    >
      <a-tooltip :title="displayName ? text[displayName] : text">
        {{ trimText(displayName ? text[displayName] : text, 16) }}
      </a-tooltip>

      <span v-if="showMeasure">litre(s)</span>
    </div>
    <p
      v-if="tagContent.length > wrapNumber"
      class="inline-block px-2 py-1 text-xs font-medium text-gray-600 border cursor-pointer border-inputGrey-600 rounded-2xl bg-inputGrey-500"
    >
      + {{ tagContent.length - wrapNumber }}
    </p>
  </section>
</template>

<script>
import { trimText } from "@/core/helpers/utility";
export default {
  name: "TagList",
  data() {
    return {
      trimText,
    };
  },
  props: {
    tagContent: {
      type: Array,
      required: true,
      default: () => [],
    },
    wrapNumber: {
      type: Number,
      required: true,
    },
    displayName: {
      type: String,
      required: true,
    },
    showMeasure: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style></style>
